import { render } from "./ComponenteInputPPAConfiguracion.vue?vue&type=template&id=0c0afdd4&scoped=true"
import script from "./ComponenteInputPPAConfiguracion.vue?vue&type=script&lang=js"
export * from "./ComponenteInputPPAConfiguracion.vue?vue&type=script&lang=js"

import "./ComponenteInputPPAConfiguracion.vue?vue&type=style&index=0&id=0c0afdd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0afdd4"]])

export default __exports__